import { useSearchParams } from 'react-router-dom';

import { SECTION_IDS, SERVICE_QUERY_PARAM } from '../../../core/constants/navigation';
import { SERVICE_IDS } from '../../../core/constants/services';
import { useIsClient } from '../../../core/hooks/useIsClient';
import { site } from '../../../global/config/site';
import Reveal from '../../../common/components/Reveal/Reveal';
import { IconClock, IconGlobe, IconMail, IconUsers } from '../../../common/icons';
import ContactForm from '../forms/contact';

import '../styles/contact.css';

export default function Contact() {
    const [searchParams] = useSearchParams();
    const isClient = useIsClient();
    const requestedService = isClient ? searchParams.get(SERVICE_QUERY_PARAM) : null;
    const initialService = SERVICE_IDS.includes(requestedService) ? requestedService : '';

    return (
        <section id={SECTION_IDS.CONTACT} className="contact" aria-labelledby="contact-title">
            <div className="contact__inner layout-container">
                <Reveal className="contact__info">
                    <p className="contact__eyebrow">Contacto</p>
                    <h2 id="contact-title" className="contact__title">Hablemos de tu medio</h2>
                    <p className="contact__lead">
                        Cuéntanos en qué etapa está tu proyecto y qué quieres lograr. Te proponemos una ruta a la medida.
                    </p>

                    <ul className="contact__details">
                        <li className="contact__detail">
                            <span className="contact__detail-icon"><IconMail /></span>
                            <span>
                                <span className="contact__detail-label">Correo</span>
                                <a href={`mailto:${site.contactEmail}`} className="contact__detail-value">{site.contactEmail}</a>
                            </span>
                        </li>
                        <li className="contact__detail">
                            <span className="contact__detail-icon"><IconGlobe /></span>
                            <span>
                                <span className="contact__detail-label">Sitio web</span>
                                <span className="contact__detail-value">{site.domain}</span>
                            </span>
                        </li>
                        <li className="contact__detail">
                            <span className="contact__detail-icon"><IconUsers /></span>
                            <span>
                                <span className="contact__detail-label">Área de acción</span>
                                <span className="contact__detail-value">Medios digitales, creadores de contenido, emisoras, portales y marcas corporativas</span>
                            </span>
                        </li>
                        <li className="contact__detail">
                            <span className="contact__detail-icon"><IconClock /></span>
                            <span>
                                <span className="contact__detail-label">Respuesta</span>
                                <span className="contact__detail-value">Te contactamos en horario hábil</span>
                            </span>
                        </li>
                    </ul>
                </Reveal>

                <Reveal delay={120} className="contact__form-card">
                    {/* Remount on service change so a new deep link preselects its service. */}
                    <ContactForm key={initialService} initialService={initialService} />
                </Reveal>
            </div>
        </section>
    );
}
